import { makeFetchSlice, fetchHomeDataThunk } from 'app/redux-fetch'
import { AppDispatch } from 'app/store'
import { fetchSubscriptionHistory } from 'features/home/api'

const subscriptionHistorySlice = makeFetchSlice('fetchSubscriptionsHistory')

export const subscriptionHistoryReducer = subscriptionHistorySlice.reducer
export const subscriptionHistoryActions = subscriptionHistorySlice.actions

export const fetchSubscriptionHistoryThunk = (
  rootDomainId: string,
  homeId: string
) => {
  return async (dispatch: AppDispatch, getState: any) => {
    try {
      const response = await fetchHomeDataThunk({
        dispatch,
        actions: subscriptionHistoryActions,
        asyncFunc: () => fetchSubscriptionHistory(rootDomainId, homeId),
      })
      return response
    } catch (error) {
      console.log('Error getting subscriptions history', error)
    }
  }
}
